import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchLastBlocks } from '../services/apiService';
import { FaCube, FaFingerprint, FaListAlt, FaTachometerAlt, FaClock, FaDatabase } from 'react-icons/fa';

const LastBlocks = () => {
  const [blocks, setBlocks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blocksPerPage = 10;

  useEffect(() => {
    fetchLastBlocks().then((data) => {
      const sortedData = data.sort((a, b) => b.height - a.height); // Ordenar por Height descendente
      setBlocks(sortedData);
    });
  }, []);

  // Calcular bloques paginados
  const indexOfLastBlock = currentPage * blocksPerPage;
  const indexOfFirstBlock = indexOfLastBlock - blocksPerPage;
  const currentBlocks = blocks.slice(indexOfFirstBlock, indexOfLastBlock);
  const totalPages = Math.ceil(blocks.length / blocksPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const getTimeElapsed = (blockTime) => {
    if (!blockTime) return '';
    const now = new Date();
    const blockDate = new Date(blockTime);
    const diffInSeconds = Math.floor((now - blockDate) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} seg`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes} min`;
    } else {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours} h`;
    }
  };

  const formatHash = (hash) => {
    const start = hash.slice(0, 8);
    const end = hash.slice(-8);
    return `${start}...${end}`;
  };

  return (
    <div className="bg-white shadow-md rounded p-4">
      <table className="table-auto w-full text-left">
        <thead>
          <tr>
            <th><FaCube /> Height</th>
            <th><FaFingerprint /> Hash</th>
            <th><FaListAlt /> nTx</th>
            <th><FaTachometerAlt /> Diffi</th>
            <th><FaDatabase /> Size</th>
            <th><FaClock /> Conf</th>
            <th>Time</th>
          </tr>
        </thead>
        <tbody>
          {currentBlocks.map((block) => (
            <tr key={block.block_hash} className="border-b">
              <td>
                <Link to={`/block-hash/${block.block_hash}`} className="text-blue-500 hover:underline">
                  {block.height}
                </Link>
              </td>
              <td>
                <Link to={`/block-hash/${block.block_hash}`} className="text-blue-500 hover:underline">
                  {formatHash(block.block_hash)}
                </Link>
              </td>
              <td>{block.nTx}</td>
              <td>{block.difficulty.toFixed(6)}</td>
              <td>{block.size} bytes</td>
              <td>{block.confirmations}</td>
              <td>{getTimeElapsed(block.time)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Paginación */}
      <div className="flex justify-between items-center mt-4">
        <button
          className={`px-4 py-2 text-sm rounded ${currentPage === 1 ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          className={`px-4 py-2 text-sm rounded ${currentPage === totalPages ? 'bg-gray-300' : 'bg-blue-500 text-white'}`}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default LastBlocks;
